import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { Transition, useStyles } from './styles';

const EstablecimientoDetails = ({ details, onClose, openDetails }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={openDetails}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogContent style={{ display: 'flex', flexWrap: 'wrap' }}>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Estado</Typography>
          <Typography className={classes.subTitles}>
            {details.estado === '1' ? 'Activo' : 'Inactivo'}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Score</Typography>
          <Typography className={classes.subTitles}>
            {details.score_actas}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Nombre Establecimiento</Typography>
          <Typography className={classes.subTitles}>
            {details.nombre_establecimiento}
          </Typography>
        </div>

        <div className={classes.titlesContainer}>
          <Typography className={classes.titles}>Codigo Destinatario</Typography>
          <Typography className={classes.subTitles}>
            {details.codigo_destinatario}
          </Typography>
        </div>

        <div className={classes.linesContainer}>
          <Typography className={classes.titles}>Ciudades</Typography>
          <div>
            {details.establecimientoCiudades?.map((est) => (
              <Typography key={est.id_ciudad} className={classes.subTitles}>
                {est. nombre_ciudad} - {est.nombre_departamento}
              </Typography>
            ))}
          </div>
        </div>


        <div className={classes.linesContainer}>
          <Typography className={classes.titles}>Vehículos</Typography>
          <div>
            {details.establecimientoVehiculos?.map((est) => (
              <Typography key={est.id_vehiculo} className={classes.subTitles}>
                {est.nombre_vehiculo}
              </Typography>
            ))}
          </div>
        </div>

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="warning">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EstablecimientoDetails;
